import { render } from "./AnimCard.vue?vue&type=template&id=37b67a5d&scoped=true"
import script from "./AnimCard.vue?vue&type=script&lang=js"
export * from "./AnimCard.vue?vue&type=script&lang=js"

import "./AnimCard.vue?vue&type=style&index=0&id=37b67a5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b67a5d"]])

export default __exports__